<template>
  <div id="app">
    <tanitimMail ref="tanitimdialog" :servisTipi="3"></tanitimMail>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp
      v-bind:mesaj="text1"
      v-model="snackbar"
      v-bind:color="snackbarkColor"
    ></snackbarcomp>
     <v-dialog v-model="dialogtedarikciGuncelle" persi persistent max-width="800">
<v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span class="white--text">{{ 'Tedarikçi Düzenle' }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text>
         
 <v-layout row wrap>
                  <v-flex xs12 sm6 md12>
                    <v-text-field v-model="guncellenecekTedarikci.ad" label="Tedarikçi" :readonly="true""></v-text-field>
                  </v-flex>
                  
                
                   <v-flex xs12 sm6 md6>
                    <v-text-field v-model="guncellenecekTedarikci.username" label="Kullanıcı"></v-text-field>
                  </v-flex>
                    <v-flex xs12 sm6 md6>
                     <v-text-field v-model="guncellenecekTedarikci.password" :label="$t('Password')"></v-text-field>
                  </v-flex>
                   <v-flex xs12 sm6 md12>
                     <v-text-field v-model="guncellenecekTedarikci.securityKey" label="Güvenlik Anahtarı "></v-text-field>
                  </v-flex>
                 </v-layout>
                    <v-layout row wrap>
                       <v-flex xs12 sm12 md8>
                    <v-text-field v-model="guncellenecekTedarikci.url" label="Servis Adresi"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 v-if="guncellenecekTedarikci.ad=='Turna'">
                      <v-autocomplete
                      ref="acenteAutoGuncelle"
            hide-details
            clearable
            :items="itemsairlinelist"
            v-model="prmAcenteKodu"
            :label="$t('Agency-Code-Select')"
            item-text="Title"
            item-value="HavaYoluKodu"
            :rules="agencyRulesGuncelle"
            
          ></v-autocomplete>
                  </v-flex>
                     </v-layout>
        </v-card-text>
         <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn color="info" @click="providerGuncelle()"   dark><span
                  class=""> {{ 'Güncelle' }}
                </span>
                       
                      </v-btn>
          <v-btn @click="dialogtedarikciGuncelle = false"  color="info">
            {{$t('Close')}}
          </v-btn>
         
        </v-card-actions>
      </v-card>
     </v-dialog>
    <v-dialog v-model="dialogtedarikci" persi persistent max-width="1200">
      <v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span class="white--text">{{ $t('Supplier') }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text>
          
        <v-form ref="formgunluksatis" lazy-validation>
          <v-card flat class="pa-3">
           
             
                <v-layout row wrap>
                 
                  <v-flex xs12 sm6 md4>
                    <v-select :items="tedarikciItems" v-model="seciliTedarikci" label="Tedarikçi"  item-text="urunAdi" item-value="id" return-object></v-select>
                  </v-flex>
                  
                
                   <v-flex xs12 sm6 md3>
                    <v-text-field v-model="tedarikci.username" label="Kullanıcı"></v-text-field>
                  </v-flex>
                    <v-flex xs12 sm6 md3>
                     <v-text-field v-model="tedarikci.password" :label="$t('Password')"></v-text-field>
                  </v-flex>
                   <v-flex xs12 sm6 md2>
                     <v-text-field v-model="tedarikci.securityKey" label="Güvenlik Anahtarı "></v-text-field>
                  </v-flex>
                 </v-layout>
                    <v-layout row wrap>
                       <v-flex xs12 sm12 md8>
                    <v-text-field v-model="tedarikci.url" label="Servis Adresi"></v-text-field>
                  </v-flex>
                  
                   <v-flex xs12 sm12 md3 v-if="prmacentesec">
                  
                     <v-autocomplete
                     ref="acenteAutoEkle"
            hide-details
            clearable
            :items="itemsairlinelist"
            v-model="prmAcenteKodu"
            :label="$t('Agency-Code-Select')"
            item-text="Title"
            item-value="HavaYoluKodu"
            :rules="agencyRules"
          ></v-autocomplete> 
                 
                  </v-flex>
                  
                    <v-flex xs12 sm12 md1 class="text-xs-right">
                     <v-btn color="info" @click="providerEkle()"   dark><span
                  class=""> {{ $t('Add') }}
                </span>
                        <v-icon right dark>add_box</v-icon>
                      </v-btn>
                   </v-flex>
                     </v-layout>
                 

               
              
             
          
          </v-card>
        </v-form>
      
           
          <v-container fluid grid-list-sm>
        <v-data-table
          :rows-per-page-items="[100]"
          :headers="headerstedarikci"
          :items="itemsproviders"
        >
          <template slot="items" slot-scope="props">
            <tr item>
              <td class="logo-cell">
              
          <v-img :src="getImgUrl(props.item.Provider)" alt="logo" cover></v-img>
       
                 
              </td>
               <td class="text-xs-left">
                {{ props.item.Provider }}
              </td>
              <td class="text-xs-left">
                {{ props.item.ServiceUsername }}
              </td>
              <td class="text-xs-left">
                {{ props.item.ServicePassword }}
              </td>
              <td class="text-xs-left">
                {{ props.item.ServiceSecurityKey }}
              </td>
               <td class="text-xs-left">
                {{ props.item.url }}
              </td>
              <td class="text-xs-right">
                <v-btn color="info" @click="providerGuncelleAc(props.item)" fab small>
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
        
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogtedarikci = false" outline color="info">
            {{$t('Close')}}
          </v-btn>
         
        </v-card-actions>
      </v-card>
      </v-dialog>
    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t("Search-Flight") }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn  slot="activator" @click="tedarikcidialogac" flat> <v-icon left dark>add_box</v-icon> <span
                  class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{ $t('Supplier-Info') }}   </span>
                </span>
               
              </v-btn>
             
            </v-tooltip>
          </v-toolbar>
        </v-flex>

    

        <!-- Arama  Filtre Gun DEgistirme -->
        <ucusara
          @showList="showTickets($event)"
          @filterList="filterTicketList($event)"
          @setFlightType="setFlightType($event)"
           @setisDomesticRT="setisDomesticRT($event)"
        ></ucusara>

        <!-- bilet listesi -->
        <ucuslist
          :ticketList="ticketList"
          :FlightType="FlightType"
          :isActive="ActiveType"
          :isDomesticRT="isDomesticRT"
        ></ucuslist>

        <v-flex xs12 sm12 md12 class="text-xs-center" v-if="ActiveType==false"  pa-2>
          <v-card>
            <v-card-title primary-title>
              <blockquote class="blockquote font-weight-medium">
                <v-icon right dark>contact_mail</v-icon>
                {{ $t('supplier-warning')}}
                </blockquote>
            </v-card-title>
          </v-card>
         
        </v-flex>
        <v-flex v-if="0 >= ticketList.length" class="justify-center" pa-2>
          <v-card>
            <v-card-title primary-title>
              <blockquote class="blockquote">
                   {{ $t('runner-v8') }}
                  <v-btn
                    color="blue-grey"
                    class="white--text"
                    @click="irtibatDialog()"
                  >
                    {{ $t('CONTACT-US') }}
                    <v-icon right dark>contact_mail</v-icon>
                  </v-btn>
                </blockquote>
            </v-card-title>
         <v-card-text>
          <v-layout row  wrap>
            <v-flex xs12 sm12 md3 class="text-xs-center">
              <img height="60px" width="50%"
                                                src="../../../../assets/images/thy.png"  alt="Arkman">
            </v-flex>
            <v-flex xs12 sm12 md3 class="text-xs-center">
              <img height="60px" width="50%"
                                                src="../../../../assets/images/ajet.png"  alt="Arkman">
            </v-flex>
            <v-flex xs12 sm12 md3 class="text-xs-center">
              <img height="60px" width="50%"
                                                src="../../../../assets/images/pegasus.png"  alt="Arkman">
            </v-flex>
            <v-flex xs12 sm12 md3 class="text-xs-center">
              <v-layout align-center="" row wrap justify-center=""> <img height="60px" width="50%"
                src="../../../../assets/images/airarabia.png"  alt="Arkman">
                                               
                                                <div>
                                                  <div class="kurdele">{{ $t('coming-soon') }}</div>
                                                </div>
                                              </v-layout>
             
            </v-flex>
          </v-layout><br><br>
          <v-layout row  wrap >
         
            <v-flex xs12 sm12 md3 class="justify-center text-xs-center" pa-2>
              <img height="60px" width="50%"
                                                src="../../../../assets/images/turnacom.png"  alt="Arkman">
            </v-flex>
            <v-flex xs12 sm12 md3 class="justify-center text-xs-center" pa-2>
              <v-layout align-center="" row wrap justify-center="">   <img height="60px" width="50%"
                src="../../../../assets/images/aerticket.png"  alt="Arkman">
                                               
                                                <div>
                                                  <div class="kurdele">{{ $t('coming-soon') }}</div>
                                                </div>
                                              </v-layout>
            
            </v-flex>
            <v-flex xs12 sm12 md3 class="text-xs-center">
              <v-layout align-center="" row wrap justify-center="">    <img height="60px" width="50%"
                src="../../../../assets/images/aertuerk.png"  alt="Arkman">
                                               
                                                <div>
                                                  <div class="kurdele">{{ $t('coming-soon') }}</div>
                                                </div>
                                              </v-layout>
             
            </v-flex>
            <v-flex xs12 sm12 md3 class="text-xs-center">
              <v-layout align-center="" row wrap justify-center=""> <img height="60px" width="50%"
                src="../../../../assets/images/easygds.png"  alt="Arkman">
                                               
                                                <div>
                                                  <div class="kurdele"> {{ $t('coming-soon') }}</div>
                                                </div>
                                              </v-layout>
             
            </v-flex>
          </v-layout>
        </v-card-text> 
         <!-- <img src="../../../../assets/images/aer.png" class="responsive"/> -->
          </v-card>
         
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import ucusara from "../comp/ucak/ucusara.vue";
import ucuslist from "../comp/ucak/ucuslistGuncel.vue";
import auth from "@/api/auth.js";
import tanitimMail from "@/components/app/customcomp/tanitimMail.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihim from "@/components/app/customcomp/tarihim";
import logo from '@/assets/images/thy.png';
import FlightFareCards from "../comp/ucak/FlightFareCards.vue";
export default {
  data() {
    return {
      agencyRules: [
      v => (this.prmacentesec ? !!v || "Bu alan zorunludur" : true)
    ],
      agencyRulesGuncelle: [
      v => (this.guncellenecekTedarikci.ad=='Turna' ? !!v || "Bu alan zorunludur" : true)
    ],
      prmacentesec:false,
      prmAcenteKodu:null,
        itemsairlinelist: [],
       guncellenecekTedarikci:{
          ad:'',
        id:0,
        username:'',
        password:'',
        url:'',
        securityKey:''
       },
       firmaBilgileri:null,
       bookingUserName:'',
       bookingUserPassword:'',
       itemsproviders:[],
       headerstedarikci: [
        {
          text:"",
        },
        {
          text:"Provider",
        },
        {
          text: "Kullanıcı",
        },
        {
          text: "Şifre",
        },
        {
          text: "Güvenlik Anahtarı",
        },
         {
          text: "URL",
        },
         {
          text: "Düzenle",
        },
       
      ],
      tedarikciItems:[
         {
            urunAdi: 'TurkishAirlines',
            id:0
           
          },
          {
           
            urunAdi: 'Pegasus',
             id:1
          },
          {
           
            urunAdi: 'OnurAir',
            id:2
          },
          {
          
            urunAdi: 'SunExpress',
             id:3
          },
          {
           
            urunAdi: 'BiletBank',
            id:4
          },
          {
           
            urunAdi: 'Amadeus',
            id:5
          },
          {
            
            urunAdi: 'AerTicket',
             id:6
          },
          {
           
            urunAdi: 'Ajet',
             id:7
          },
           {
           
            urunAdi: 'Turna',
             id:8
          },
            {
           
            urunAdi: 'THYNDC',
             id:9
          },
      ],
      seciliGuncelleTedarikci:null,
      seciliTedarikci:null,
      tedarikci:{
        ad:'',
        id:0,
        username:'',
        password:'',
        url:'',
        securityKey:''

      },
      dialogtedarikciGuncelle:false,
      dialogtedarikci:false,
      items: [
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg",
        },
      ],
      ticketList: [],
      filterBackupTicketList: [],
      snackbarkColor: "black",
      number: 1,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      FlightType: null,
      ActiveType: null,
      isDomesticRT:false,
      ucuAraPrms:{
        SessionHeader: {
    SessionId: "M8YdiSXb2uwuzwo",
    SessionToken: "b0c67d31-79f0-4d05-a028-48a53c934ec4"
  },
  AirSearchOptions: {
    FlightType: "OW",
    CabinType: "Economy",
    RefundableType: "AllFlights",
    Currency: "TRY",
    DirectFlightsOnly: false,
    AvailableFlightsOnly: true,
    FareDisplayType: "Lowest"
  },
  AirSearchPaxItems: [
    {
      "PaxCode": "ADT",
      "PaxCount": 1
    }
  ],
  AirSearchSegments: [
    {
      SequenceNo: 1,
      DepartureDay: "2024.06.21",
      Origin: {
        AirportCode: "IST",
        IsCity: false
      },
      Destination: {
        AirportCode: "AYT",
        IsCity: false
      }
    }
  ]


      }
    };
  },
  watch: {
  seciliTedarikci(newVal) {
    if (!newVal) return;

    if (newVal.id === 8) {
      this.tedarikci.url="https://api.turna.com/v1";
      this.prmacentesec=true;
    } else {
      this.prmacentesec=false;
      this.tedarikci.url="";
    }
  }
},
  methods: {
    getAirlinesCodes(){
 var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var params = {
        CompanyCode: credentials.SirketKodu
      }

      this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.itemsairlinelist = response.body
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'

          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'

          this.snackbar = true
        }
      })
    },
     onSelectFare({ flight, fare }) {
     
      console.log("Seçilen:", fare.FareName, fare.TotalFare);
    },
      getImgUrl(prv) {
       
      if (prv=="TurkishAirlines")
      {
          return require('@/assets/images/TK.png')
      }
      if (prv=="Turna")
      {
          return require('@/assets/images/turnacom.png')
      }
      if (prv=="Pegasus")
      {
          return require('@/assets/images/pegasus.png')
      }
       if (prv=="Ajet")
      {
          return require('@/assets/images/ajet.png')
      }
        if (prv=="Amadeus")
      {
          return require('@/assets/images/Amadeus_Logo.png')
      }
      
    },
    providerGuncelleAc(val)
    {
      this.prmAcenteKodu=val.OfficeId;
      this.guncellenecekTedarikci.ad=val.Provider;
      this.guncellenecekTedarikci.id=val.Id;
      this.guncellenecekTedarikci.username=val.ServiceUsername;
      try{
this.guncellenecekTedarikci.url=val.url;
      }catch{

      }
        
       this.guncellenecekTedarikci.password=val.ServicePassword;
        this.guncellenecekTedarikci.securityKey=val.ServiceSecurityKey;
       this.dialogtedarikciGuncelle=true;
    },
    providerGuncelle()
    {
       if (this.guncellenecekTedarikci.ad=="Turna"){
        const valid = this.$refs.acenteAutoGuncelle.validate();

         if (!valid) {
       this.text1 = "Lütfen Bir Acente Kodu Seçin";
              this.loadingvmodel = false;
              this.snackbar = true;
      return;
    }
        
      }
var params = {
  SessionHeader: {

    SessionId: this.ucuAraPrms.SessionHeader.SessionId, 
    SessionToken: this.ucuAraPrms.SessionHeader.SessionToken    },
    Provider:this.guncellenecekTedarikci.ad,
    ProviderType:'Air',
    ServiceUsername:this.guncellenecekTedarikci.username,
    ServicePassword:this.guncellenecekTedarikci.password,
    ServiceSecurityKey:this.guncellenecekTedarikci.securityKey,
    Address:this.guncellenecekTedarikci.url,
    IsTest: true,
    IsActive: true,
    OfficeId:this.prmAcenteKodu
      }
       this.$http
        .post(auth.BOOKING_API_URL + "Agency/EditCredential", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
        
            if (response.body.HasError==false)
           {
            this.getProviders();
            this.dialogtedarikciGuncelle=false;
           
           }

          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "EditCredential - Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = "EditCredential - Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
    providerEkle()
    {
       if (this.seciliTedarikci.id==8){
        const valid = this.$refs.acenteAutoEkle.validate();

         if (!valid) {
       this.text1 = "Lütfen Bir Acente Kodu Seçin";
              this.loadingvmodel = false;
              this.snackbar = true;
      return;
    }}
var params = {
  SessionHeader: {
    SessionId: this.ucuAraPrms.SessionHeader.SessionId, 
    SessionToken: this.ucuAraPrms.SessionHeader.SessionToken    },
    Provider:this.seciliTedarikci.urunAdi,
    ProviderType:'Air',
    ServiceUsername:this.tedarikci.username,
    ServicePassword:this.tedarikci.password,
    ServiceSecurityKey:this.tedarikci.securityKey,
    Address:this.tedarikci.url,
    OfficeId:this.prmAcenteKodu,
    IsTest: false
      }
       this.$http
        .post(auth.BOOKING_API_URL + "Agency/AddCredential", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
        
            if (response.body.HasError==false)
           {
            this.getProviders();
            this.seciliTedarikci==null;
            this.tedarikci.username='';
            this.tedarikci.password='';
            this.tedarikci.securityKey='';
            this.tedarikci.url='';
           }

          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "AddCredential - Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = "AddCredential - Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
    tedarikcidialogac()
    {
         this.getProviders();
         this.dialogtedarikci=true;
    },
   
    async addAgency2()
    {
      this.loadingvmodel = true;
 var credentials = JSON.parse(window.localStorage.getItem("credentials"));

var params={
  Name:credentials.CoperSirketAdi,
  City:this.firmaBilgileri.City,
  District:this.firmaBilgileri.District,
  CountryCode:"TR",
  Address:this.firmaBilgileri.Address,
  Gsm:this.firmaBilgileri.Gsm,
  Email:this.firmaBilgileri.Email,
  TaxOffice:this.firmaBilgileri.TaxOffice,
  TaxNo:this.firmaBilgileri.TaxNo,
IsActive:true};

  this.$http
        .post(auth.BOOKING_API_URL + "Agency/AddAgency", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
         (response) => {
     
         if (response.body.Usernanme!=null)
         {
          this.bookingUserName=response.body.Username;
          this.bookingUserPassword=response.body.Password;
         }
           
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "AddAgency - Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
              return false;
            } else {
              this.text1 = "AddAgency - Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
              return false;
            }
          }
        );
       this.loadingvmodel = false;
        return true;
       
    },
async FirmaBilgileriGetir() {
  this.loadingvmodel =true;
  try {
    const credentials = JSON.parse(window.localStorage.getItem("credentials"));
    const paramscompany = {
      SirketKodu: credentials.SirketKodu
    };
    const responsecompany = await this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', paramscompany, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    });

    this.firmaBilgileri = {
      Name: credentials.CoperSirketAdi,
      City: responsecompany.body.Il,
      District: responsecompany.body.Ilce,
      CountryCode: "TR",
      Address: responsecompany.body.Adres,
      Gsm: responsecompany.body.Tel,
      Email: responsecompany.body.Email,
      TaxOffice: responsecompany.body.VergiDairesi,
      TaxNo: responsecompany.body.VergiNo
    };

    if (!this.firmaBilgileri.Email || !this.firmaBilgileri.TaxNo) {
      this.text1 = "Firma Mail Adresi veya Vergi Numarası Bulunamadı";
      this.loadingvmodel = false;
      this.snackbar = true;
      return false;
    }
    this.loadingvmodel = false;
    return true;
  } catch (error) {
    this.text1 = "CompanyGet - Service Unavailable";
    this.loadingvmodel = false;
    this.snackbar = true;
    return false;
  }
},

async EkurunGetir() {
  this.loadingvmodel = true;
  try {
    const params3 = {
      GrupID: null,
      UrunID: null,
      MusteriID: null
    };

    const response = await this.$http.post(auth.API_URL + 'api/Awed/ExtraProductGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    });

    const ekurun = response.body[3].Aktif;

    if (!ekurun) {
      this.text1 = "Pazar Yeri Ürünü Bulunamadı";
      this.loadingvmodel = false;
      this.snackbar = true;
      return false;
    }
this.loadingvmodel = false;
    return true;
  } catch (error) {
    this.text1 = "ExtraProductGroupList - Service Unavailable";
    this.loadingvmodel = false;
    this.snackbar = true;
    return false;
  }
},

async chkAgency() {
  this.loadingvmodel = true;
  try {
    const params = {
      Email: this.firmaBilgileri.Email,
      TaxNo: this.firmaBilgileri.TaxNo,
    };
    const response = await this.$http.post(auth.BOOKING_API_URL + 'Agency/CheckAgency', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    });
   
    if (response.body.HasError)
    {
      this.loadingvmodel = false;
       return false;
    }
    else
    {
      this.loadingvmodel = false;
          this.bookingUserName=response.body.Username;
          this.bookingUserPassword=response.body.Password;
          return true;
    }
  } catch (error) {
    this.loadingvmodel = false;
  
    return false;
  }
},

async BookingKontrol() {
  const coperFirmaBilgileri = await this.FirmaBilgileriGetir();
  if (!coperFirmaBilgileri) {
    return;
  }

  const ekUrunVar = await this.EkurunGetir();
  if (!ekUrunVar) {
    return;
  }

  
const firmaVar = await this.chkAgency();
let firmaEklendi = false; 

if (!firmaVar) {
  firmaEklendi = await this.addAgency2();
  if (!firmaEklendi) {
    return;
  }else{
await this.login();
  }
}
else{

  await this.login();

  
}


  
},
    getEkUrun()
    {
          var params3 = {
          GrupID: null,
          UrunID: null,
          MusteriID: null
        }

        this.$http.post(auth.API_URL + 'api/Awed/ExtraProductGroupList', params3, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }

        ).then((response) => {

          var ekurun=response.body[3].Aktif;
        if (ekurun)
        {
          
             this.CheckAgency2();
        }
            
        });
    },
    getProviders()
    {
      this.prmAcenteKodu=null;
      this.getAirlinesCodes();
      this.itemsproviders=[];
 var params = {
  SessionHeader: {
    SessionId: this.ucuAraPrms.SessionHeader.SessionId, 
    SessionToken: this.ucuAraPrms.SessionHeader.SessionToken    }
      }
       this.$http
        .post(auth.BOOKING_API_URL + "Agency/GetCredential", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
        
            var rsp=response.body.Credentials;
           rsp.forEach(element => {
            if (element.ProviderType=='Air')
           {
 var prv={
      Id:element.Id,
      Provider:element.Provider,
      ProviderType:element.ProviderType,
      ServiceUsername:element.ServiceUsername,
      ServicePassword:element.ServicePassword,
      ServiceSecurityKey:element.ServiceSecurityKey,
      OfficeId:element.OfficeId,
      url:element.Address
    }
    this.itemsproviders.push(prv);
           }
   
});

            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "GetCredential - Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = "GetCredential - Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
   async login()
    {
      this.loadingvmodel = true;
      var params = {
        Username: this.bookingUserName,
  Password: this.bookingUserPassword,
  IsTest: true

      };

      this.$http
        .post(auth.BOOKING_API_URL + "Login", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
           this.ActiveType = response.body.Active;
           this.ucuAraPrms.SessionHeader.SessionId=response.body.SessionId;
           this.ucuAraPrms.SessionHeader.SessionToken=response.body.SessionToken;
            window.localStorage.setItem(
              "bookingParams",
              JSON.stringify(response.body)
            );
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Login - Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            } else {
              this.text1 = "Login - Service Unavailable";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
    irtibatDialog() {
      this.$refs.tanitimdialog.open(0);
    },
    getAccountDetails() {
      // this.loadingvmodel = true;
      // var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      // var params = {
      //   CustomerID: credentials.MusteriID,
      //   ServiceID: 1
      // };

      // this.$http
      //   .post(auth.API_URL + "api/Booking/ServiceInfoLoad", params, {
      //     headers: {
      //       Authorization: "Bearer " + auth.getAuthHeader(),
      //     },
      //   })
      //   .then(
      //     (response) => {
      //       auth.BOOKING_API_URL = auth.BOOKING_API_URL;//response.body.Url;
      //       this.ActiveType = response.body.Active;
      //       this.loadingvmodel = false;
      //     },
      //     (response) => {
      //       if (response.status === 0) {
      //         this.text1 = "Service Unavailable";
      //         this.loadingvmodel = false;
      //         this.snackbar = true;
      //       } else {
      //         this.text1 = "Service Unavailable";
      //         this.loadingvmodel = false;
      //         this.snackbar = true;
      //       }
      //     }
      //   );
    },
    setFlightType(value) {
      this.FlightType = value;
    },
     setisDomesticRT(value) {
      
      this.isDomesticRT = value;
    },
   
    filterTicketList(value) {
  console.log(value);

  // Helper functions
  var getFareType = function (t) {
    if (!t || !t.PricingInfo) return null;
    if (t.PricingInfo.FareInfoType) return t.PricingInfo.FareInfoType;
    var fb = t.PricingInfo.FareBreakdowns;
    if (fb && fb.length > 0 && fb[0] && fb[0].FareInfoType) {
      return fb[0].FareInfoType;
    }
    return null;
  };

  var isNonStopBySegments = function (t) {
    if (!t || !t.FlightSegments || !t.FlightSegments.length) return false;
    var segs = t.FlightSegments;
    var counts = {};
    var hasDirection = false;

    for (var i = 0; i < segs.length; i++) {
      var seg = segs[i];
      if (!seg) continue;
      if (seg.DirectionInd === 0 || seg.DirectionInd === 1 || seg.DirectionInd === "0" || seg.DirectionInd === "1") {
        hasDirection = true;
        var key = String(seg.DirectionInd);
        counts[key] = (counts[key] || 0) + 1;
      }
    }

    if (hasDirection) {
      for (var k in counts) {
        if (counts.hasOwnProperty(k) && counts[k] > 1) return false;
      }
      if (segs.length === 2 && counts["0"] === 1 && counts["1"] === 1) return true;
      if (segs.length === 1) return true;
      return false;
    }
    return segs.length === 1;
  };

  var isTransferBySegments = function (t) {
    return !isNonStopBySegments(t);
  };

  // Başlangıç listesi
  const source = this.filterBackupTicketList || [];
  let filtered = source;

  // 1. FİYAT FİLTRESİ
  if (value.ticketPrice != null && value.ticketPrice > 0) {
    const limit = value.ticketPrice * 1;
    filtered = filtered.filter(function(x) {
      return x.TotalFare <= limit;
    });
  }

  // 2. KALKIŞ SAATİ FİLTRESİ
  if (value.timeDepartureRange && value.timeDepartureRange.length === 2) {
    const startHour = value.timeDepartureRange[0];
    const endHour = value.timeDepartureRange[1];
    if (startHour != null && endHour != null) {
      const startMin = startHour * 60;
      const endMin = endHour * 60;
      filtered = filtered.filter(function(t) {
        var segs = (t && t.FlightSegments) ? t.FlightSegments : [];
        return segs.some(function(seg) {
          if (!seg || !seg.DepartureTime) return false;
          var parts = seg.DepartureTime.split(":");
          var h = parseInt(parts[0], 10);
          var m = parseInt(parts[1] || "0", 10);
          var tMin = (h * 60) + m;
          return tMin >= startMin && tMin <= endMin;
        });
      });
    }
  }

  // 3. VARIŞ SAATİ FİLTRESİ
  if (value.timeDestinationRange && value.timeDestinationRange.length === 2) {
    const startHour = value.timeDestinationRange[0];
    const endHour = value.timeDestinationRange[1];
    if (startHour != null && endHour != null) {
      const startMin = startHour * 60;
      const endMin = endHour * 60;
      filtered = filtered.filter(function(t) {
        var segs = (t && t.FlightSegments) ? t.FlightSegments : [];
        return segs.some(function(seg) {
          if (!seg || !seg.ArrivalTime) return false;
          var parts = seg.ArrivalTime.split(":");
          var h = parseInt(parts[0], 10);
          var m = parseInt(parts[1] || "0", 10);
          var tMin = (h * 60) + m;
          return tMin >= startMin && tMin <= endMin;
        });
      });
    }
  }

  // 4. DIRECT / TRANSFER FİLTRESİ
  const directOn = value.direct === true;
  const transferOn = value.transfer === true;

  if (directOn && !transferOn) {
    // Sadece direkt uçuşlar
    filtered = filtered.filter(function(t) {
      return isNonStopBySegments(t);
    });
  } else if (!directOn && transferOn) {
    // Sadece aktarmalı uçuşlar
    filtered = filtered.filter(function(t) {
      return isTransferBySegments(t);
    });
  }
  // İkisi de seçili veya ikisi de kapalıysa filtre uygulanmaz

  // 5. HAVAYOLU FİLTRESİ
  if (value.airline && Array.isArray(value.airline)) {
    const selectedCodes = value.airline
      .filter(function(a) { return a.value === true; })
      .map(function(a) { return a.code; });

    if (selectedCodes.length > 0) {
      filtered = filtered.filter(function(t) {
        return (t.FlightSegments || []).some(function(seg) {
          return selectedCodes.includes(seg.MarkettingAirline);
        });
      });
    }
  }

  // 6. FLEX / PROMO FİLTRESİ
  const flexOn = value.flex === true;
  const promoOn = value.promo === true;

  if (flexOn && !promoOn) {
    // Sadece Flex
    filtered = filtered.filter(function(t) {
      return getFareType(t) === "Flex";
    });
  } else if (!flexOn && promoOn) {
    // Sadece Promo
    filtered = filtered.filter(function(t) {
      return getFareType(t) === "Promo";
    });
  }
  // İkisi de seçili veya ikisi de kapalıysa filtre uygulanmaz

  // Sonucu ata
  this.ticketList = filtered;
},

    filterTicketList2(value) {
      console.log(value);
      //1 : fiyat - 2 : saat Departure - 3: saat Arrival - 4 : direct fly - 5 : transfer fly 6: Airline 7: flex 8 : promo
      switch (value.type) {
        case 1:
          alert('1');
          var euroPrice = (value.ticketPrice / value.currency) * 1;
          this.ticketList = this.filterBackupTicketList.filter(
            (element) => euroPrice <= element.TotalFare
          );
          break;
        case 2:
          var timeDepartureStart = value.timeDepartureRange[0];
          var timeDepartureEnd = value.timeDepartureRange[1];
          if (timeDepartureStart > 9) {
            timeDepartureStart = timeDepartureStart + ":00";
          } else {
            timeDepartureEnd = "0" + timeDepartureEnd + ":00";
          }
          if (timeDepartureEnd > 9) {
            timeDepartureEnd = timeDepartureEnd + ":00";
          } else {
            timeDepartureEnd = "0" + timeDepartureEnd + ":00";
          }
          this.ticketList = [];
          for (
            let index = 0;
            index < this.filterBackupTicketList.length;
            index++
          ) {
            const element = this.filterBackupTicketList[index];

            for (let i = 0; i < element.FlightSegments.length; i++) {
              const item = element.FlightSegments[i];

              if (
                item.DepartureTime >= timeDepartureEnd &&
                item.DepartureTime <= timeDepartureEnd
              ) {
                this.ticketList.push(element);
              }
            }
          }
          break;
        // eslint-disable-next-line no-duplicate-case
        case 3:
          var timeDestinationStart = value.timeDestinationRange[0];
          var timeDestinationEnd = value.timeDestinationRange[1];
          if (timeDestinationStart > 9) {
            timeDestinationStart = timeDestinationStart + ":00";
          } else {
            timeDestinationStart = "0" + timeDestinationStart + ":00";
          }
          if (timeDestinationEnd > 9) {
            timeDestinationEnd = timeDestinationEnd + ":00";
          } else {
            timeDestinationEnd = "0" + timeDestinationEnd + ":00";
          }
          this.ticketList = [];
          for (
            let index = 0;
            index < this.filterBackupTicketList.length;
            index++
          ) {
            const element = this.filterBackupTicketList[index];

            for (let i = 0; i < element.FlightSegments.length; i++) {
              const item = element.FlightSegments[i];

              if (
                item.ArrivalTime >= timeDestinationStart &&
                item.ArrivalTime <= timeDestinationEnd
              ) {
                this.ticketList.push(element);
              }
            }
          }
          break;
        case 4:
          //FlightSegments.IsConnected == true aktarma var
          if (value.direct) {
           
            this.ticketList = [];
            for (
              let index = 0;
              index < this.filterBackupTicketList.length;
              index++
            ) {
              const element = this.filterBackupTicketList[index];

              for (let i = 0; i < element.FlightSegments.length; i++) {
                const item = element.FlightSegments[i];

                if (item.IsConnected == false) {
                  this.ticketList.push(element);
                }
              }
            }
          } else {
           
            this.ticketList = [];
            for (
              let index = 0;
              index < this.filterBackupTicketList.length;
              index++
            ) {
              const element = this.filterBackupTicketList[index];

              for (let i = 0; i < element.FlightSegments.length; i++) {
                const item = element.FlightSegments[i];

                if (item.IsConnected == true) {
                  this.ticketList.push(element);
                }
              }
            }
          }
          break;
        case 5:
          if (value.transfer && !value.direct) {
            this.ticketList = [];
            for (
              let index = 0;
              index < this.filterBackupTicketList.length;
              index++
            ) {
              const element = this.filterBackupTicketList[index];

              for (let i = 0; i < element.FlightSegments.length; i++) {
                const item = element.FlightSegments[i];

                if (item.IsConnected == true) {
                  this.ticketList.push(element);
                }
              }
            }
          } else {
            this.ticketList = [];
            for (
              let index = 0;
              index < this.filterBackupTicketList.length;
              index++
            ) {
              const element = this.filterBackupTicketList[index];

              for (let i = 0; i < element.FlightSegments.length; i++) {
                const item = element.FlightSegments[i];

                if (item.IsConnected == false) {
                  this.ticketList.push(element);
                }
              }
            }
          }
          break;
        case 6:
          var newTicketList = [];
          var LastTicketList = [];
          var controlList = 0;
          value.airline.forEach((element) => {
            if (element.value == true) {
              let result = this.filterBackupTicketList.filter((filterElement) =>
                filterElement.FlightSegments.find(
                  (data) => data.MarkettingAirline === element.code
                )
              );
              if (controlList == 0) {
                LastTicketList = newTicketList.concat(result);
              } else {
                LastTicketList = LastTicketList.concat(result);
              }
            }
            controlList = 2;
          });

          this.ticketList = LastTicketList;

          break;
        case 7:
          if (value.flex == true) {
            let filterItem = this.filterBackupTicketList.filter(
              (element) => element.PricingInfo.FareInfoType == "Flex"
            );
            this.ticketList = filterItem;
          } else {
            let filterItem = this.filterBackupTicketList.filter(
              (element) => element.PricingInfo.FareInfoType != "Flex"
            );
            this.ticketList = filterItem;
          }
          break;
        case 8:
          if (value.promo == true) {
            let filterItem = this.filterBackupTicketList.filter(
              (element) => element.PricingInfo.FareInfoType == "Promo"
            );
            this.ticketList = filterItem;
          } else {
            let filterItem = this.filterBackupTicketList.filter(
              (element) => element.PricingInfo.FareInfoType != "Promo"
            );
            this.ticketList = filterItem;
          }
          break;
        default:
          break;
      }
    },
    showTickets(value) {
      
      this.ticketList = value;
      this.filterBackupTicketList = value;
    },

  //   getToken() {
     
  //     var credentials = JSON.parse(window.localStorage.getItem("credentials"));

  //     var params = {
  //       Username: "Arkgsa",
  // Password: "3paPVcsbbpf5Lwj",
  // IsTest: true

  //     };

  //     this.$http
  //       .post(auth.BOOKING_API_URL + "Login", params, {
  //         headers: {
  //           Authorization: "Bearer " + auth.getAuthHeader(),
  //         },
  //       })
  //       .then(
  //         (response) => {
  //           window.localStorage.setItem(
  //             "bookingParams",
  //             JSON.stringify(response.body)
  //           );
  //           this.ActiveType = response.body.Active;
  //         },
  //         (response) => {
  //           if (response.status === 0) {
  //             this.text1 = "Service Unavailable-BookingLogin";
  //             this.snackbar = true;
  //           } else {
  //             this.text1 = "Service Unavailable-BookingLogin";
  //             this.snackbar = true;
  //           }
  //         }
  //       );
  //   },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    ucusara,
    ucuslist,
    tanitimMail,
    tarihim,
    FlightFareCards
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    
    if (this.sayfayetki.Status == true) {
    this.BookingKontrol();
      //YETKİ OK
      
      this.getAccountDetails();
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
};
</script>

<style scoped>
.logo-cell {
  position: relative;
  width: 120px;     
  height: 60px;      
  padding: 0 !important;        
}

.logo-cell .v-img {
  width: 100% !important;
  height: 100% !important;
}
.rounded-corner {
  border-start-start-radius: 20px;
  border-end-end-radius: 20px;
}
.responsive {
  max-width: 100%;
  height: auto;
}
.kurdele-alani {
    width: 85px;
    height: 88px;
    overflow: hidden;
    position: absolute;
    top: -3px;
    right: -3px;
  }

  .kurdele {
    font: 13px Sans-Serif;
    color: rgb(255, 255, 255);
    text-align: center;
    text-shadow: rgba(255, 255, 255, 0.5) 0px 1px 0px;
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    position: relative;
    padding: 7px 0;
    left: -8px;
    top: 10px;
    width: 120px;
    background-color: #2196F3;
    background-image: -webkit-gradient(linear, left top, left bottom, from(#BFDC7A), to(#8EBF45));
    background-image: -webkit-linear-gradient(top, #BFDC7A, #8EBF45);
    background-image: -moz-linear-gradient(top, #BFDC7A, #8EBF45);
    background-image: -ms-linear-gradient(top, #BFDC7A, #8EBF45);
    background-image: -o-linear-gradient(top, #BFDC7A, #8EBF45);
    -webkit-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
  }

  .kurdele:before,
  .kurdele:after {
    content: "";
    border-top: 3px solid #6e8900;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    position: absolute;
    bottom: -3px;
  }

  .kurdele:before {
    left: 0;
  }

  .kurdele:after {
    right: 0;
  }
</style>

